export default __webpack_public_path__ + "static/what-are-we-doing-4-a182fc45565abdb5e8660b3579ca201a.png";